import { Tab, TabList } from "@fluentui/react-components";
import { useState, type FC } from "react";
import { useNotificationHistoryHeaderStyles } from "./styles";

interface NotificationHistoryHeaderProps {
  filteredCount: number;
  totalCount: number;
}

const NotificationHistoryHeader: FC<NotificationHistoryHeaderProps> = ({
  filteredCount,
  totalCount,
}) => {
  const styles = useNotificationHistoryHeaderStyles();
  const [selectedTab, setSelectedTab] = useState("history");

  return (
    <header className={styles.header}>
      <TabList
        selectedValue={selectedTab}
        onTabSelect={(_, data) => setSelectedTab(data.value as string)}
        size="large"
      >
        <Tab value="history" style={{ minWidth: "120px" }}>
          Logs ( {filteredCount} / {totalCount} )
        </Tab>
      </TabList>
    </header>
  );
};

export default NotificationHistoryHeader;
